import React, { useState, useEffect, useContext } from 'react'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Paper from '@mui/material/Paper'
import Stack from '@mui/material/Stack'
import StatusCard from '../../../components/Cards/StatusCard'
import FolderSharedIcon from '@mui/icons-material/FolderShared'
import API from '../../../services/API'
import Existing from './Existing'
import { SiteModeContext } from '../../../components/mainFrame/MainFrame'
import { EPCRContext } from './EPCR'
import SmallModal from '../../../components/Modals/SmallModal'
import { Typography } from '@mui/material'
import { useNavigate } from 'react-router-dom'

const EPCRDashboard = ({}) => {
  const [epcrCount, setEpcrCount] = useState({})
  const [draftsRecents, setDraftsRecents] = useState('')
  const [openConfirmPractice, setOpenConfirmPractice] = useState(false)
  const { setExistingRecord, setSiteMode, setEpcrPracticeMode } =
    useContext(SiteModeContext)
  const [loadingCounts, setLoadingCounts] = useState(true)
  const navigate = useNavigate()

  useEffect(() => {
    API.get('my-epcr-count')
      .then((res) => res.status === 200 && setEpcrCount(res.data))
      .finally(() => setLoadingCounts(false))
  }, [])
  return (
    <Stack gap={1} useFlexGap>
      {draftsRecents ? (
        <Existing
          setDraftsRecents={setDraftsRecents}
          draftsRecents={draftsRecents}
        />
      ) : (
        <Stack component={Paper} padding={1} gap={1}>
          <Stack direction={{ xs: 'column', lg: 'row' }} gap={1}>
            <StatusCard
              label="ePCR's in Progress"
              number={epcrCount?.drafts ?? 0}
              color={1}
              icon={FolderSharedIcon}
              onClick={() =>
                epcrCount?.drafts > 0 && setDraftsRecents('drafts')
              }
              loading={loadingCounts}
            />
            <StatusCard
              label="My Recent ePCR's"
              number={epcrCount?.recents ?? 0}
              color={2}
              icon={FolderSharedIcon}
              // onClick={() =>
              //   epcrCount?.recents > 0 && setDraftsRecents('recents')
              // }
              onClick={() => {
                navigate('/epcr/recents')
              }}
            />
          </Stack>
          <Button
            onClick={() => setOpenConfirmPractice(true)}
            variant="outlined"
            color="warning"
          >
            Practice ePCR
          </Button>
          <SmallModal
            open={openConfirmPractice}
            onClose={() => setOpenConfirmPractice(false)}
          >
            <Stack gap={1} alignItems="center">
              <Typography variant="title3" fontSize="1rem">
                Are you sure you want to start a practice ePCR?
              </Typography>
              <Typography variant="caption">
                This cannot be used for real patients and you cannot save the
                form.
              </Typography>
              <Button
                size="small"
                variant="contained"
                color="info"
                fullWidth
                onClick={() => {
                  setExistingRecord(null)
                  setSiteMode('ePCR')
                  setEpcrPracticeMode(true)
                }}
              >
                Yes - Continue
              </Button>
              <Button
                size="small"
                variant="contained"
                color="error"
                fullWidth
                onClick={() => setOpenConfirmPractice(false)}
              >
                No - Cancel
              </Button>
            </Stack>
          </SmallModal>
          <Button
            onClick={() => {
              setExistingRecord(null)
              setSiteMode('ePCR')
            }}
            variant="contained"
            color="success"
          >
            Start New ePCR
          </Button>
        </Stack>
      )}
    </Stack>
  )
}

export default EPCRDashboard
